export default "__VITE_ASSET__ce53d313__"